module.exports = __webpack_public_path__ + "img/markers-soft@2x.ad459aeb.png";